module.exports = __webpack_public_path__ + "f9d0f8396f1e9c06a95a2e5acc2176a7.MP3";